var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 2a.91.91 0 0 1 .91.91v1.817a.91.91 0 1 1-1.82 0V2.91A.91.91 0 0 1 12 2M4.903 4.903a.91.91 0 0 1 1.285 0l1.286 1.285a.91.91 0 0 1-1.286 1.286L4.903 6.188a.91.91 0 0 1 0-1.285m14.195 0a.91.91 0 0 1 0 1.285l-1.286 1.286a.909.909 0 1 1-1.286-1.286l1.286-1.285a.91.91 0 0 1 1.285 0M6.544 12a5.455 5.455 0 1 1 10.91 0 5.455 5.455 0 0 1-10.91 0M2 12a.91.91 0 0 1 .91-.91h1.817a.91.91 0 1 1 0 1.82H2.91A.91.91 0 0 1 2 12m16.364 0a.91.91 0 0 1 .909-.91h1.818a.91.91 0 1 1 0 1.82h-1.818a.91.91 0 0 1-.91-.91m-10.89 4.53a.91.91 0 0 1 0 1.286L6.188 19.1a.91.91 0 0 1-1.285-1.285l1.285-1.286a.91.91 0 0 1 1.286 0m9.052 0a.91.91 0 0 1 1.286 0l1.285 1.286a.91.91 0 1 1-1.285 1.285l-1.286-1.285a.91.91 0 0 1 0-1.286M12 18.364a.91.91 0 0 1 .91.909v1.818a.91.91 0 1 1-1.82 0v-1.818a.91.91 0 0 1 .91-.91",
    clipRule: "evenodd"
  })));
};
export default SvgSun;